"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themeNames = void 0;
var themeNames = exports.themeNames = ['im-light', 'im-dark'];